import { SIGN_IN, SIGN_UP, LOG_OUT, SET_ISREADY } from './../actionTypes'
const initialState = {
  isReady: false,
  isAuthenticated: false,
  authData: {},
}
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SIGN_UP:
      return {
        ...state,
        isReady: true,
        authData: action?.payload,
      }
    case SIGN_IN:
      return {
        ...state,
        isReady: true,
        isAuthenticated: true,
        authData: action?.payload,
      }
    case LOG_OUT:
      return {
        ...state,
        isReady: true,
        isAuthenticated: false,
        authData: {},
      }
    case SET_ISREADY:
      return {
        ...state,
        isReady: true,
      }
    default:
      return state
  }
}
